import * as React from "react"
import Layout from "../components/Layout"
import { StaticImage } from "gatsby-plugin-image"
import Contact from "../components/Contact/Contact"
import Seo from "../components/SEO"
import SimpleBanner from "../components/SimpleBanner/SimpleBanner"

const contact = () => {
  return (
    <>
      <Seo title="Contact" />
      <Layout>
        <SimpleBanner title="Make it easy. Just text us 760.552.4216">
          <StaticImage
            className="banner__image"
            src="../../static/evoke-homepage.jpg"
            alt="Evoke Offroad sick truck"
          />
        </SimpleBanner>
        <Contact />
      </Layout>
    </>
  )
}

export default contact
